import clsx from 'clsx'

type Status = 'healthy' | 'warning' | 'critical' | 'info' | 'neutral' | 'offline'

interface StatusBadgeProps {
  status: Status
  label?: string
  showDot?: boolean
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const statusConfig = {
  healthy: {
    bg: 'bg-status-healthy/20',
    text: 'text-status-healthy',
    dot: 'bg-status-healthy',
    label: 'Healthy'
  },
  warning: {
    bg: 'bg-status-warning/20',
    text: 'text-status-warning',
    dot: 'bg-status-warning',
    label: 'Warning'
  },
  critical: {
    bg: 'bg-status-critical/20',
    text: 'text-status-critical',
    dot: 'bg-status-critical',
    label: 'Critical'
  },
  info: {
    bg: 'bg-status-info/20',
    text: 'text-status-info',
    dot: 'bg-status-info',
    label: 'Info'
  },
  neutral: {
    bg: 'bg-surface-600/20',
    text: 'text-surface-400',
    dot: 'bg-surface-400',
    label: 'Unknown'
  },
  offline: {
    bg: 'bg-surface-700/20',
    text: 'text-surface-500',
    dot: 'bg-surface-500',
    label: 'Offline'
  }
}

const sizes = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2 py-1 text-xs',
  lg: 'px-3 py-1.5 text-sm'
}

export default function StatusBadge({
  status,
  label,
  showDot = true,
  size = 'md',
  className
}: StatusBadgeProps) {
  const config = statusConfig[status]

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-md font-medium',
        config.bg,
        config.text,
        sizes[size],
        className
      )}
    >
      {showDot && (
        <span className={clsx('w-1.5 h-1.5 rounded-full', config.dot)} />
      )}
      {label || config.label}
    </span>
  )
}
